import type { WebrtcCallUiPhase } from '@/lib/telnyxCallState';

/**
 * El leg WebRTC suele pasar a `active` antes de que el cliente PSTN conteste.
 * Si hay `crm_calls`, la fuente de verdad del “contestó” es `call_status === answered` (webhook).
 *
 * Sin UUID de CRM **no** asumimos conversación: evita “En llamada · 0:xx” mientras timbra el auto-call.
 */
export function isPstnAnsweredForUi(
  crmCallId: string | null | undefined,
  crmCallStatus: string | null | undefined,
): boolean {
  if (!crmCallId?.trim()) return false;
  return crmCallStatus?.trim().toLowerCase() === 'answered';
}

/** Cronómetro de conversación: solo tras `answered` con fila CRM. */
export function shouldRunConversationClock(
  callPhase: WebrtcCallUiPhase,
  crmCallId: string | null | undefined,
  crmCallStatus: string | null | undefined,
): boolean {
  return callPhase === 'active' && isPstnAnsweredForUi(crmCallId, crmCallStatus);
}
